import designItem from './DesignRadio.vue'
const DesignRadio = {
  install: function (Vue) {
    Vue.component('DesignRadio', designItem)
  }
}
export default DesignRadio
